import { apikeyBugsnagBeta } from "../index";
import { IEnvConfig } from "@aspen/model";
const protocol = "https:";
const staticHost = `${protocol}//static.beta.test-aspendigital.co/`;
export const betaConfig: IEnvConfig = {
  env: "beta",
  host: {
    dev: `${protocol}//api2.beta.test-aspendigital.co/`,
    prod: `${protocol}//api2.beta.test-aspendigital.co/`
  },
  klineChartUrl: `${staticHost}klinechart/index.html`,
  tvChartUrl: "https://tradingview-nextjs-javascript-git-beta-aspendigital.vercel.app",
  websocket: {
    host: "wss://ws.beta.test-aspendigital.co:1443"
  },
  apiKeyBugsnag: apikeyBugsnagBeta,
  webDomain: "https://portal.beta.test-aspendigital.co",
  domainUriPrefix: "https://betaaspendigital.page.link",
  fallbackUrl: {
    android: "https://www.pgyer.com/3dd275ece49d8e93df4c84461f258aed",
    ios: "https://www.pgyer.com/ec5209f9ab52485f233170905738b490"
  },
  packageName: {
    android: "com.beta.aspen",
    ios: "org.evg.beta.aspen"
  },
  minimumVersion: {
    android: "107",
    ios: "1.3.2"
  },
  operationServer: "https://api.aoperation.beta.test-aspendigital.co/",
  saasServer: "https://api.beta-asportal.co/"
};
